// api/instance.ts
import axios from "axios";
import {toast} from "react-toastify";
import {firebase_sign_out, getAuthToken} from "../services/firebase_services";
import {reportApiError} from "../services/sentry";

// Set per environment, baked in at build time: .env (local), .env.production (prod build),
// or the hosting provider's env settings (staging), which override the files
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export const instance = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    }
});

// Errors the response interceptor below already shows a toast for; pages skip their own message for these
const TOASTED_CODES = ["PLAN_LIMIT_REACHED", "EMAIL_NOT_VERIFIED", "RATE_LIMITED"];
export const isAlreadyToasted = (error: any) => TOASTED_CODES.includes(error?.response?.data?.code);

instance.interceptors.request.use(async (config) => {
    const token = await getAuthToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
}, (error) => Promise.reject(error));


instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        reportApiError(error);

        if (error.message === "Network Error") {
            toast.error("Network Error");
        }

        if (error.response?.status === 401) {
            await firebase_sign_out();
            window.location.href = "/auth";
        }

        if (error.response?.data?.code === "RATE_LIMITED") {
            toast.error(error.response.data.message);
        }

        if (error.response?.data?.code === "EMAIL_NOT_VERIFIED") {
            toast.error(error.response.data.message);
        }

        if (error.response?.data?.code === "PLAN_LIMIT_REACHED") {
            toast.error(`${error.response.data.message} Upgrade your plan in Settings.`);
        }

        return Promise.reject(error);
    }
);
